import React from 'react';
import { SectionLabel } from './SectionLabel';
import { Bloom } from './Bloom';
import { DeviceMockup } from './visuals/DeviceMockup';
import { automations } from '../data/howItWorks';
const chatLines = [{
  from: 'system' as const,
  text: "Hey Maria, still good for your estimate tomorrow at 10am?"
}, {
  from: 'customer' as const,
  text: "Yes! See you then"
}, {
  from: 'system' as const,
  text: "Great, thanks for the 5-star review! Means a lot to us."
}];

/* Pairs the automations list with a real text-thread mockup instead of a
   third text-card grid -- the section's own copy ("a lead that goes quiet
   gets chased on its own") is exactly what a follow-up/reminder/review-ask
   thread looks like, so showing one is more convincing than another
   bullet list. Visual sits first on desktop for rhythm against the CRM
   section above it (visual-then-text there, text-then-visual here). */
export function AutomationsSection() {
  return <section className="relative isolate overflow-hidden border-b border-[#1a1a1a]" data-id="element-137" data-mp="12jrxth2ct2wn">
      <Bloom size="md" className="right-0 top-[-6rem]" data-id="element-138" data-mp="22h9prc64p7mp" />
      <div className="mx-auto grid w-full max-w-6xl grid-cols-1 items-center gap-14 px-6 py-20 lg:grid-cols-2 lg:py-24" data-id="element-139" data-mp="1xi6jxpibqxdo">
        <div className="order-first lg:order-none" data-id="element-140" data-mp="2cfywq9whl7o6">
          <DeviceMockup mode="chat" heading="Automated follow-up" lines={chatLines} data-id="element-141" data-mp="2cckynduuvkmj" />
        </div>
        <div data-id="element-142" data-mp="27i74ferxjjjg">
          <SectionLabel data-id="element-143" data-mp="2lfcc1j7akqgt">Automations</SectionLabel>
          <h2 className="mt-8 text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-144" data-mp="2le17hh60veon">
            Nobody goes cold because you got busy.
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-neutral-400" data-id="element-145" data-mp="2v5osp0bzjzho">
            Built with you on a call, in your voice. Then they run without you.
          </p>
          <ul className="mt-8 space-y-4" data-id="element-146" data-mp="3463fk44llmna">
            {automations.map(f => <li key={f.title} className="flex gap-3 text-sm leading-relaxed text-neutral-300" data-id="element-147" data-mp="3440tfv6kgdnu">
                <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-emerald-500" aria-hidden="true" data-id="element-148" data-mp="302f95orpcx3m" />
                <span data-id="element-149" data-mp="3c7uiz5g367bz">
                  <span className="font-semibold text-white" data-id="element-150" data-mp="3c72qi3hscppx">{f.title}.</span> {f.body}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}